export const CLAIM = "CLAIM";
export const MOBILE_APPS_PROMO_CLAIM = "MOBILE_APPS_PROMO_CLAIM";
export const GET_MEMBER_LUCK_DRAW_INFO = "GET_MEMBER_LUCK_DRAW_INFO";